module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intro"
  }, [_vm._m(0), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "workshop",
    attrs: {
      "id": "workshop"
    }
  }, [_vm._m(1), _vm._m(2), _vm._m(3), _vm._m(4), _vm._m(5), _c('div', {
    staticClass: "expert-wapper"
  }, [_c('ul', _vm._l((_vm.expert.items), function(item, $index) {
    return _c('li', {
      staticClass: "expert-item"
    }, [_c('img', {
      attrs: {
        "src": ['/static/img/' + item.pic]
      }
    }), _c('div', {
      staticClass: "info"
    }, [_c('p', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.name))]), _c('p', {
      staticClass: "from"
    }, [_vm._v(_vm._s(item.from))]), _c('p', {
      staticClass: "position",
      domProps: {
        "innerHTML": _vm._s(item.position)
      }
    }), _c('p', {
      staticClass: "from"
    }, [_vm._v(_vm._s(item.from2))]), _c('p', {
      staticClass: "position",
      domProps: {
        "innerHTML": _vm._s(item.position2)
      }
    })]), _c('p', {
      staticClass: "brief"
    }, [_vm._v(_vm._s(item.brief))])])
  }), 0)]), _c('div', {
    staticClass: "tips"
  }, [_vm._v("* 极客公园正在通过以上嘉宾连接全球最优秀的前沿科技研究者，部分嘉宾也将参与前沿工作坊。")])])]), _c('div', {
    attrs: {
      "id": "fieldstudy"
    }
  }), _c('div', {
    staticClass: "field-study"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(6), _c('div', {
    staticClass: "fieldstudy-list"
  }, [_c('div', {
    staticClass: "tag"
  }, [_vm._v(_vm._s(_vm.slides.length && _vm.slides[_vm.currentSlide].tag))]), _c('swiper', {
    ref: "mySwiper",
    staticClass: "out",
    attrs: {
      "options": _vm.swiperOption
    }
  }, _vm._l((_vm.slides), function(guest, index) {
    return _c('swiper-slide', {
      key: ("guest_" + index)
    }, [_c('div', {
      staticClass: "item"
    }, [_c('img', {
      attrs: {
        "src": require(("../assets/imgs/fieldstudy/" + (guest.pic) + ".jpg"))
      }
    }), _c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(guest.title))]), _c('div', {
      staticClass: "description"
    }, [_vm._v(_vm._s(guest.description))])])])
  }), 1)], 1)])]), _c('div', {
    attrs: {
      "id": "overclocking"
    }
  }), _c('div', {
    staticClass: "overclocking-camp"
  }, [_c('div', {
    staticClass: "container bg-map"
  }, [_vm._m(7), _vm._m(8), _c('div', {
    staticClass: "intro-step"
  }, [_c('div', {
    staticClass: "intro-step-item"
  }, [_c('h3', [_vm._v("「前沿之前」超频之旅")]), _c('p', [_c('icon-clock'), _vm._v("5月 "), _c('icon-location'), _vm._v("英国")], 1)]), _c('div', {
    staticClass: "intro-step-item"
  }, [_c('h3', [_vm._v("「探索前沿与商业」超频之旅")]), _c('p', [_c('icon-clock'), _vm._v("9月 "), _c('icon-location'), _vm._v("美国")], 1)]), _c('div', {
    staticClass: "intro-step-item"
  }, [_c('h3', [_vm._v("Web Summit破冰之旅")]), _c('p', [_c('icon-clock'), _vm._v("11月 "), _c('icon-location'), _vm._v("葡萄牙")], 1)])]), _vm._m(9), _vm._m(10), _vm._m(11), _c('div', {
    staticClass: "member"
  }, [_c('ul', _vm._l((_vm.entrepreneurs), function(name, $index) {
    return _c('li', {
      staticClass: "member-item"
    }, [_c('p', {
      staticClass: "name"
    }, [_vm._v(_vm._s(name))]), _c('p', {
      staticClass: "company"
    }, [_vm._v(_vm._s(_vm.members[name].company))]), _c('p', {
      staticClass: "position",
      domProps: {
        "innerHTML": _vm._s(_vm.members[name].position)
      }
    })])
  }), 0)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cover"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v("前沿社如何帮到你？")]), _c('div', {
    staticClass: "guide"
  }, [_c('a', {
    staticClass: "guide-item",
    attrs: {
      "href": "#workshop"
    }
  }, [_c('p', [_vm._v("Frontier Workshop")]), _c('p', [_vm._v("前沿工作坊")])]), _c('a', {
    staticClass: "guide-item",
    attrs: {
      "href": "#fieldstudy"
    }
  }, [_c('p', [_vm._v("Field Study")]), _c('p', [_vm._v("近场研究")])]), _c('a', {
    staticClass: "guide-item",
    attrs: {
      "href": "#overclocking"
    }
  }, [_c('p', [_vm._v("Overclocking Camp")]), _c('p', [_vm._v("超频之旅")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intro-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/intro_v1.jpg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intro-title"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h1', [_vm._v("Frontier")]), _c('h1', [_vm._v("Workshop")]), _c('h1', {
    staticClass: "cn"
  }, [_vm._v("前沿工作坊")])]), _c('p', [_vm._v("在世界级科学家的顾问和推荐下，每年与来自全球顶级学府的超过 20 位前沿科技研究者产生连接，深入了解全球最领先的科技，提供市场化视角的思考、对未来产品与应用的建议，为实验室项目商业化提供路径。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subhead"
  }, [_c('h2', [_vm._v("2019年关注领域")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module"
  }, [_c('div', {
    staticClass: "module-item"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("5G 通讯")]), _c('div', {
    staticClass: "item-subtitle"
  }, [_vm._v("5G")]), _c('div', {
    staticClass: "cover-tips"
  }, [_vm._v("更高速的连接和更低的延时，将成为哪些领域的引爆点？又将创造哪些新的应用场景？")])]), _c('div', {
    staticClass: "module-item"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("智能制造")]), _c('div', {
    staticClass: "item-subtitle"
  }, [_vm._v("Intelligent"), _c('br'), _vm._v("Manufacturing")]), _c('div', {
    staticClass: "cover-tips"
  }, [_vm._v("更密集的生产数据和明确的用户需求，将如何改造传统的制造流程？")])]), _c('div', {
    staticClass: "module-item"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("AI 落地")]), _c('div', {
    staticClass: "item-subtitle"
  }, [_vm._v("Landing AI")]), _c('div', {
    staticClass: "cover-tips"
  }, [_vm._v("强算力如何提升传统行业的效率？跳脱思维局限，选择AI更广泛地落脚点。")])]), _c('div', {
    staticClass: "module-item"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("未来出行")]), _c('div', {
    staticClass: "item-subtitle"
  }, [_vm._v("Future"), _c('br'), _vm._v("Transportation")]), _c('div', {
    staticClass: "cover-tips"
  }, [_vm._v("算法如何与场景和硬件成本达到动态平衡？又如何预期天马行空出行方式的落地可行性？")])]), _c('div', {
    staticClass: "module-item"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("核心元器件")]), _c('div', {
    staticClass: "item-subtitle"
  }, [_vm._v("Core Electronic"), _c('br'), _vm._v("Components")]), _c('div', {
    staticClass: "cover-tips"
  }, [_vm._v("关注国内核心通用元器件的商业路径，发现焦点之外元器件的技术突破。")])]), _c('div', {
    staticClass: "module-item"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("更多前沿领域")]), _c('div', {
    staticClass: "item-subtitle"
  }, [_vm._v("More...")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subhead"
  }, [_c('h2', [_vm._v("与全球最权威的专家共同思考")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intro-title"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h1', [_vm._v("Field")]), _c('h1', [_vm._v("Study")]), _c('h1', {
    staticClass: "cn"
  }, [_vm._v("近场研究")])]), _c('p', [_vm._v("CEO 对 CEO，真问题对真问题。每期走进一家优秀热门科技公司，通过 CEO 间内部探讨和闭门交流，促进有价值的思考，推动经验分享与洞见碰撞，推动没有边界的创新思维和合作可能。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intro-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/imgs/intro_v2.jpg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intro-title"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h1', [_vm._v("OverClocking")]), _c('h1', [_vm._v("Camp")]), _c('h1', {
    staticClass: "cn"
  }, [_vm._v("超频之旅")])]), _c('p', [_vm._v("与最优秀的企业家一起在全球范围内从前沿的科技到创新的思想，去寻求认知的突破和升级，也在共同的交流和思考之中进行思维的徒步。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subhead"
  }, [_c('h2', [_vm._v("与世界级创新者的深度交流")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "world-innovator"
  }, [_c('ul', [_c('li', [_c('img', {
    attrs: {
      "src": require("../assets/imgs/world_innovator_01.jpg")
    }
  }), _c('p', {
    staticClass: "name"
  }, [_vm._v("Elon Musk")]), _c('p', {
    staticClass: "company"
  }, [_vm._v("Tesla")]), _c('p', {
    staticClass: "position"
  }, [_vm._v("创始人&CEO")])]), _c('li', [_c('img', {
    attrs: {
      "src": require("../assets/imgs/world_innovator_02.jpg")
    }
  }), _c('p', {
    staticClass: "name"
  }, [_vm._v("John Sculley")]), _c('p', {
    staticClass: "company"
  }, [_vm._v("前Apple CEO")]), _c('p', {
    staticClass: "position"
  }, [_vm._v("风险投资人")])]), _c('li', [_c('img', {
    attrs: {
      "src": require("../assets/imgs/world_innovator_03.jpg")
    }
  }), _c('p', {
    staticClass: "name"
  }, [_vm._v("杨致远")]), _c('p', {
    staticClass: "company"
  }, [_vm._v("Yahoo")]), _c('p', {
    staticClass: "position"
  }, [_vm._v("创始人")])]), _c('li', [_c('img', {
    attrs: {
      "src": require("../assets/imgs/world_innovator_04.jpg")
    }
  }), _c('p', {
    staticClass: "name"
  }, [_vm._v("Dick Costolo")]), _c('p', {
    staticClass: "company"
  }, [_vm._v("Twitter")]), _c('p', {
    staticClass: "position"
  }, [_vm._v("前CEO")])]), _c('li', [_c('img', {
    attrs: {
      "src": require("../assets/imgs/world_innovator_05.jpg")
    }
  }), _c('p', {
    staticClass: "name"
  }, [_vm._v("Brian Chesky")]), _c('p', {
    staticClass: "company"
  }, [_vm._v("Airbnb")]), _c('p', {
    staticClass: "position"
  }, [_vm._v("创始人&CEO")])]), _c('li', [_c('img', {
    attrs: {
      "src": require("../assets/imgs/world_innovator_06.jpg")
    }
  }), _c('p', {
    staticClass: "name"
  }, [_vm._v("Ben Silbermann")]), _c('p', {
    staticClass: "company"
  }, [_vm._v("Pinterest")]), _c('p', {
    staticClass: "position"
  }, [_vm._v("创始人&CEO")])]), _c('li', [_c('img', {
    attrs: {
      "src": require("../assets/imgs/world_innovator_07.jpg")
    }
  }), _c('p', {
    staticClass: "name"
  }, [_vm._v("Alex Kipman")]), _c('p', {
    staticClass: "company"
  }, [_vm._v("微软")]), _c('p', {
    staticClass: "position"
  }, [_vm._v("全球副总裁、HoloLens总负责")])])]), _c('div', {
    staticClass: "world-innovator-more"
  }, [_c('dl', [_c('dt', [_vm._v("Harry Shum 沈向洋")]), _c('dd', [_vm._v("微软全球执行副总裁、微软全球研究院院长")]), _c('dt', [_vm._v("Alex Kipman")]), _c('dd', [_vm._v("微软全球副总裁、HoloLens总负责")]), _c('dt', [_vm._v("Scott Guthrie")]), _c('dd', [_vm._v("微软执行副总裁、主管云计算与企业级事业部")]), _c('dt', [_vm._v("陆奇")]), _c('dd', [_vm._v("前微软全球执行副总裁、应用和服务部负责人")]), _c('dt', [_vm._v("David Ku")]), _c('dd', [_vm._v("微软全球应用与服务部副总裁")]), _c('dt', [_vm._v("Alan Stern")]), _c('dd', [_vm._v("前 NASA 新地平线号首席研究员")]), _c('dt', [_vm._v("Oliver Cameron")]), _c('dd', [_vm._v("Udacity工程和产品副总裁")]), _c('dt', [_vm._v("Meron Gribetz")]), _c('dd', [_vm._v("Meta CEO")]), _c('dt', [_vm._v("杨培东")]), _c('dd', [_vm._v("伯克利大学教授、美国科学院院士、全球著名化学家、材料科学家")])]), _c('dl', [_c('dt', [_vm._v("Ryan Germick")]), _c('dd', [_vm._v("Google Design设计总监、首席设计师")]), _c('dt', [_vm._v("Nathan Burba")]), _c('dd', [_vm._v("Survios CEO")]), _c('dt', [_vm._v("David Reitze")]), _c('dd', [_vm._v("加州理工大学LIGO实验室执行总监、教授")]), _c('dt', [_vm._v("Jessica Lessin")]), _c('dd', [_vm._v("The Information 创始人")]), _c('dt', [_vm._v("Sonny Vu")]), _c('dd', [_vm._v("Misfit 创始人&CEO")]), _c('dt', [_vm._v("Yves Behar")]), _c('dd', [_vm._v("fuseproject 创始人&CEO")]), _c('dt', [_vm._v("Connie Chan")]), _c('dd', [_vm._v("Andreessen Horowitz ( A16Z）合伙人")]), _c('dt', [_vm._v("George O’Neal")]), _c('dd', [_vm._v("Hyperloop One高级副总裁")]), _c('dt', [_vm._v("James Chung")]), _c('dd', [_vm._v("Reload Studio CEO")]), _c('dt', [_vm._v("Lisa Q. Fetterman")]), _c('dd', [_vm._v("Nomiku 联合创始人、CEO")])]), _c('div', {
    staticClass: "tips"
  }, [_vm._v("* 以上为2014-2016年参与极客公园交流的部分海外嘉宾。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subhead"
  }, [_c('h2', [_vm._v("这些企业家曾参加超频之旅")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-567c9f40!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Intro.vue
// module id = 201
// module chunks = 1